import { PiUserList } from "react-icons/pi";
import { PiUserCircle } from "react-icons/pi";
import { GoTasklist } from "react-icons/go";
import { GoMultiSelect } from "react-icons/go";
import { PiHeadset } from "react-icons/pi";
import { BsPlusSquare } from "react-icons/bs";
import { PiMailbox } from "react-icons/pi";
import { GoCrossReference } from "react-icons/go";

import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getProfile } from "../redux/profile/profileSlice";
import { Icon } from "@iconify/react/dist/iconify.js";
// -----------------------------------------------------------------

const filterNavConfig = (roles, navConfig, roleTitles) => {
  // console.log(roles);
  roles = {
    it_recruiter: true,
  };
  const allowedTitles = [];

  for (const role in roles) {
    if (roles[role]) {
      allowedTitles.push(...roleTitles[role]);
    }
  }

  const menuItems = navConfig
    .filter((item) => allowedTitles.includes(item.title))
    .map((item) => ({
      title: item.title,
      path: item.path,
      icon: item.icon,
      children: item.children,
    }));

  return menuItems;
};

export const MenuItems = () => {
  const profile = useSelector((state) => state.static.data);

  console.log({ profile });

  let navConfig = [];
  if (profile === "BENCH_SALES_RECRUITER") {
    navConfig = [
      {
        title: "Profile",
        path: "/profile",
        icon: <PiUserCircle style={{ fontSize: "23.5px" }} />,
      },

      {
        title: "Candiadte Listing",
        path: "/candidate-listing",
        icon: <PiUserList style={{ fontSize: "24px" }} />,
      },
      {
        title: "Hot Openings",
        path: "/requirement",
        icon: <Icon icon="fluent:live-24-regular" height={24} width={24} />,
      },
      {
        title: "Submissions Tracker",
        path: "/submision-tracker",
        icon: (
          <Icon icon="system-uicons:document-stack" height={25} width={25} />
        ),
      },

      {
        title: "Hot List",
        path: "/hot-list",
        icon: <Icon icon="la:hotjar" height={25} width={25} />,
      },
      {
        title: "Help Desk",
        path: "/helpdesk",
        icon: <PiHeadset style={{ fontSize: "24px" }} />,
      },
      {
        title: "Invite To Recruiter",
        path: "/invite",
        icon: <GoCrossReference style={{ fontSize: "24px" }} />,
      },
      // {
      //   title: 'Candiadte Demo',
      //   path: '/candidate-demo',
      //   icon: <PiUserList style={{fontSize: '24px'}} />,
      // },
      {
        title: "Credit",
        path: "/credit",
        icon: (
          <Icon
            icon="fluent:wallet-credit-card-48-regular"
            style={{ fontSize: "26px" }}
          />
        ),
      },
      // {
      //   title: "Error Report",
      //   path: "/bugs",
      //   icon: <Icon icon="ic:outline-error-outline" height={28} width={28} />,
      // },
    ];
  } else {
    navConfig = [
      {
        title: "Profile",
        path: "/profile",
        icon: <PiUserCircle style={{ fontSize: "23.5px", color: "#424242" }} />,
      },

      {
        title: "Job Post",
        path: "/jobpost",
        icon: <BsPlusSquare style={{ fontSize: "20px", color: "#424242" }} />,
      },
      {
        title: "Profile Tracker",
        path: "/internal-tracker",
        icon: <PiUserList style={{ fontSize: "24px", color: "#424242" }} />,
      },
      {
        title: "Submission Tracker",
        path: "/submision-tracker",
        icon: (
          <Icon icon="system-uicons:document-stack" height={24} width={24} />
        ),
      },
      {
        title: "Search Candidate",
        path: "/search-candidate",
        icon: <Icon icon="mynaui:search-user" height={24} width={24} />,
      },
      {
        title: "MassMailing",
        path: "/mass-mailing",
        icon: <PiMailbox style={{ fontSize: "23px" }} />,
      },
      {
        title: "Hot List",
        path: "/hot-list-recruiters",
        icon: <Icon icon="la:hotjar" height={25} width={25} />,
      },
      {
        title: "Help Desk",
        path: "/helpdesk",
        icon: <PiHeadset style={{ fontSize: "24px" }} />,
      },
      {
        title: "Invite To Bench Sales",
        path: "/invite",
        icon: <GoCrossReference style={{ fontSize: "24px" }} />,
      },
    ];
  }

  let roleTitles = {};
  if (profile === "BENCH_SALES_RECRUITER") {
    roleTitles = {
      it_recruiter: [
        "Profile",
        "Candiadte Listing",
        "Hot Openings",
        "Submissions Tracker",
        "Help Desk",
        "Hot List",
        "Invite To Recruiter",
        "Candiadte Demo",
        "Error Report",
      ],
    };
  } else {
    roleTitles = {
      it_recruiter: [
        "Profile",
        "Job Post",
        "Profile Tracker",
        "Submission Tracker",
        "MassMailing",
        "Hot List",
        "Help Desk",
        "Invite To Bench Sales",
        "Search Candidate",
      ],
    };
  }
  // const authorise = localStorage.getItem("Authorise");
  const authorise = "it_recruiter";
  const roles = {
    it_recruiter: authorise === "admin" ? true : false,
    admin: authorise === "admin" ? true : false,
    staff: authorise === "staff" ? true : false,
    spoc: authorise === "spoc" ? true : false,
    manager: authorise === "manager" ? true : false,
    management: authorise === "management" ? true : false,
    educator: authorise === "educator" ? true : false,
    account_manager: authorise === "account_manager" ? true : false,
    talent: authorise === "talent" ? true : false,
  };

  return filterNavConfig(roles, navConfig, roleTitles);
};
